function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutline122X122Px = function SvgOutline122X122Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 122 122",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M76.3 7.2 115.8 49c7.2 7.6 6.9 19.7-.8 26.9l-41.8 39.5c-7.6 7.2-19.7 6.9-26.9-.8L6.9 72.8C-.3 65.2 0 53.2 7.7 46L49.5 6.5c7.6-7.2 19.6-6.9 26.8.7z",
    style: {
      fill: "none",
      stroke: "#e5e5e5",
      strokeWidth: 2
    }
  }));
};
export default SvgOutline122X122Px;